/**
 * A saved preset of defaults (surfaced in the UI as "Campaign") a canvasser
 * activates once per shift — see design doc §6.5. `objection_set_id`/
 * `service_ids` are inert placeholders: those concepts don't exist until
 * later phases (same forward-column pattern as `interactions.lead_id`).
 */
export interface WorkContext {
  id: string;
  name: string;
  description: string;
  default_tag_ids: string; // JSON array of tags(id), as stored
  default_interaction_type: string;
  objection_set_id: string;
  service_ids: string;
  starts_at: number | null;
  ends_at: number | null;
  is_active: number;
  created_by: string;
  created_at: number;
  updated_by: string;
  updated_at: number;
  deleted_at: number | null;
}

export interface CreateWorkContextParams {
  name: string;
  description?: string;
  default_tag_ids?: string[];
  default_interaction_type?: string;
  starts_at?: number | null;
  ends_at?: number | null;
}

export interface UpdateWorkContextParams {
  id: string;
  name?: string;
  description?: string;
  default_tag_ids?: string[];
  default_interaction_type?: string;
  starts_at?: number | null;
  ends_at?: number | null;
  is_active?: number;
}

/** Parses the stored JSON array; never throws — a malformed row degrades to no defaults. */
export function parseDefaultTagIds(context: Pick<WorkContext, 'default_tag_ids'>): string[] {
  try {
    const parsed = JSON.parse(context.default_tag_ids);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
